<template>
  <section>
    <v-btn-toggle rounded>
      <v-btn small :disabled="decreaseBtnDisabled" @click="onDecreaseBtnClick">
        <v-icon x-small>mdi-minus</v-icon>
      </v-btn>
      <v-card
        height="28"
        min-width="60"
        flat
        outlined
        tile
        class="text-center px-3 text-subtitle-2 font-weight-medium d-flex"
        style="line-height: 28px"
      >
        <div class="mx-auto">{{ quantity }}</div>
        <span v-if="isWeighted" class="ml-1">
          {{ unit }}
        </span>
      </v-card>
      <v-btn small :disabled="increaseBtnDisabled" @click="onIncreaseBtnClick">
        <v-icon x-small>mdi-plus</v-icon>
      </v-btn>
    </v-btn-toggle>
  </section>
</template>

<script>
export default {
  name: 'ProductQuantityButtons',
  props: {
    quantity: Number,
    unit: String,
    isWeighted: Boolean,
    increaseBtnDisabled: Boolean,
    decreaseBtnDisabled: Boolean,
  },
  emits: ['decrease', 'increase'],
  data() {
    return {};
  },
  methods: {
    onDecreaseBtnClick() {
      this.$emit('decrease');
    },
    onIncreaseBtnClick() {
      this.$emit('increase');
    },
  },
};
</script>
